import { render, staticRenderFns } from "./tenantInstructionDialog.vue?vue&type=template&id=20512897&"
import script from "./tenantInstructionDialog.vue?vue&type=script&lang=js&"
export * from "./tenantInstructionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20512897')) {
      api.createRecord('20512897', component.options)
    } else {
      api.reload('20512897', component.options)
    }
    module.hot.accept("./tenantInstructionDialog.vue?vue&type=template&id=20512897&", function () {
      api.rerender('20512897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionDialog.vue"
export default component.exports